import { useMemo } from "react";
import { TimeframeValue } from "@volca/ui/components/ui/time-frame-filter";
import { dayjs, getDateRangeFromTimeFrame } from "@/core/utils/date";
import { multiFieldSearch } from "@/core/utils/multi-field-search";
import type { IReferral } from "./referral";
import { REFERRAL_SEARCH_FIELDS } from "./search-constants";

export const useFilteredReferrals = (
  referrals: IReferral[],
  searchValue: string,
  timeframeValue: TimeframeValue,
) =>
  useMemo(() => {
    let filtered = referrals;

    if (searchValue) {
      filtered = multiFieldSearch(
        filtered,
        searchValue,
        REFERRAL_SEARCH_FIELDS,
      );
    }

    const range = getDateRangeFromTimeFrame(timeframeValue);
    if (range) {
      filtered = filtered.filter((referral) => {
        const createdAt = dayjs(referral.created_at);
        return (
          !createdAt.isBefore(range.startDate) &&
          !createdAt.isAfter(range.endDate)
        );
      });
    }

    return filtered;
  }, [referrals, searchValue, timeframeValue]);
